/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GenericProductCategory } from './genericProductCategory';
import { ProductSummary } from './productSummary';

export interface CategorySummaryDTO {
  category?: string;
  categoryId?: number;
  categoryLevel?: number;
  categoryName?: string;
  externalId?: number;
  externalIdString?: string;
  parentId?: number;
  productIds?: Array<number>;
  products?: number;
  productsList?: Array<ProductSummary>;
  subcategories?: number;
  subcategoriesList?: Array<GenericProductCategory>;
}
